import { Col, FormFeedback } from "reactstrap";
import { LabelText } from "../Utils/Input";
import InputField from "../Utils/InputField";

export default function FormLine1({
  touched,
  errors,
  handleChange,
  handleBlur,
  values,
}) {
  return (
    <>
      <Col xxl={3} md={6}>
        <LabelText
          htmlFor={"stationID"}
          className={"text-danger"}
          displayText={"Station ID"}
          important={"*"}
        />
        <LabelText
          htmlFor={"stationID"}
          classLabelName={`d-block ms-0 rv-sub-label ${
            touched.stationID && errors.stationID
              ? "rv-label-danger"
              : "rv-label-muted"
          } `}
          displayText={
            touched.stationID && errors.stationID
              ? errors.stationID
              : "Enter Station ID"
          }
        />
        <InputField
          name={"stationID"}
          type={"text"}
          className={"form-control"}
          id={"stationID"}
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={values.stationID || ""}
          invalid={touched.stationID && errors.stationID ? true : false}
        />
      </Col>
      <Col xxl={3} md={6}>
        <LabelText
          htmlFor={"name"}
          className={"text-danger"}
          displayText={"Station Name"}
          important={"*"}
        />
        <LabelText
          htmlFor={"name"}
          classLabelName={`d-block ms-0 rv-sub-label ${
            touched.name && errors.name ? "rv-label-danger" : "rv-label-muted"
          } `}
          displayText={
            touched.name && errors.name ? errors.name : "Enter Station Name"
          }
        />
        <InputField
          name={"name"}
          type={"text"}
          className={"form-control"}
          id={"name"}
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={values.name || ""}
          invalid={touched.name && errors.name ? true : false}
        />
      </Col>
      <Col xxl={3} md={6}>
        <LabelText
          htmlFor={"serialNumber"}
          displayText={"Serial Number"}
          className={"text-danger"}
          important={"*"}
        />
        <LabelText
          htmlFor={"serialNumber"}
          classLabelName={`d-block ms-0 rv-sub-label ${
            touched.serialNumber && errors.serialNumber
              ? "rv-label-danger"
              : "rv-label-muted"
          } `}
          displayText={
            touched.serialNumber && errors.serialNumber
              ? errors.serialNumber
              : "Enter Serial Number"
          }
        />
        <InputField
          name={"serialNumber"}
          type={"text"}
          className={"form-control"}
          id={"serialNumber"}
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={values.serialNumber || ""}
          invalid={touched.serialNumber && errors.serialNumber ? true : false}
        />
      </Col>
      <Col xxl={3} md={6}>
        <LabelText
          htmlFor={"address_line1"}
          className={"text-danger"}
          displayText={"Address line 1"}
          important={"*"}
        />
        <LabelText
          htmlFor={"address_line1"}
          classLabelName={`d-block ms-0 rv-sub-label ${
            touched.address_line1 && errors.address_line1
              ? "rv-label-danger"
              : "rv-label-muted"
          } `}
          displayText={
            touched.address_line1 && errors.address_line1
              ? errors.address_line1
              : "Enter Address 1"
          }
        />
        <InputField
          name={"address_line1"}
          type={"text"}
          className={"form-control"}
          id={"address_line1"}
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={values.address_line1 || ""}
          invalid={touched.address_line1 && errors.address_line1 ? true : false}
        />
      </Col>
      <Col xxl={3} md={6}>
        <LabelText
          htmlFor={"address_line2"}
          className={"text-danger"}
          displayText={"Address line 2"}
          important={"*"}
        />
        <LabelText
          htmlFor={"address_line2"}
          classLabelName={`d-block ms-0 rv-sub-label ${
            touched.address_line2 && errors.address_line2
              ? "rv-label-danger"
              : "rv-label-muted"
          } `}
          displayText={
            touched.address_line2 && errors.address_line2
              ? errors.address_line2
              : "Enter Address 2"
          }
        />
        <InputField
          name={"address_line2"}
          type={"text"}
          className={"form-control"}
          id={"address_line2"}
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={values.address_line2 || ""}
          invalid={touched.address_line2 && errors.address_line2 ? true : false}
        />
      </Col>
    </>
  );
}
